import { useContext } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useSubscriptionTier } from '../../utils/hooks/useSubscriptionTier';
import { FirstTimeFlag } from '../../redux/firstTimeFlags';
import { useFirstTimeFlag } from '../../redux/firstTimeFlags/hooks';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useDeviationViewContext } from '../../Context';
import { DeviationTypes } from '../../types/deviation';
import { getDeviationType } from '../../DeviationViews/_helpers';
export function useSubscriptionLockFTUE(deviation) {
    const { isLoggedIn  } = useContext(SessionContext);
    const { isInTier , isOwner , isUserSubscribed  } = useSubscriptionTier(deviation);
    const { hasFlag: isMsLockedArtNotSeen , dropFlag  } = useFirstTimeFlag(FirstTimeFlag.IsMsLockedArtNotSeen);
    return {
        isSubscriptionLockFTUEShown: !isUserSubscribed && isLoggedIn && isInTier && !isOwner && isMsLockedArtNotSeen,
        dropFlag
    };
}
export function useSubscriptionLockSidebarFTUE(contentType, deviation) {
    const isMobile = useContext(MobileContext);
    const { isTheater  } = useDeviationViewContext();
    const { isSubscriptionLockFTUEShown , dropFlag  } = useSubscriptionLockFTUE(deviation);
    return {
        isShowingSubscriptionsFTUE: // do we need to show it at all
        isSubscriptionLockFTUEShown && // mobile doesnt get this madness
        !isMobile && // only the in_tiers block gets it
        contentType === 'in_tiers' && // the non-lit ftue relies on having the sidebar on the right and not below, so only in !theater
        ![
            DeviationTypes.JOURNAL,
            DeviationTypes.LITERATURE
        ].includes(getDeviationType(deviation)) && !isTheater,
        dropFlag
    };
}
